import { FC, useEffect } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../../../modules/auth'
import { queryCache } from '../../../../queries/client'
import { Link } from 'react-router-dom'
import { useLogout } from '../../../modules/auth/core/_requests'

const NoAccess: FC = () => {
  // const { logout } = useAuth()
  // const loginMutation = useLogout()

  useEffect(() => {
    const redirectingURl =
      `${process.env.REACT_APP_ID_SERVER_CLIENT_URL}/landing/explore/investor` || ''
    window.location.href = redirectingURl
  }, [])

  return null
  // <div className='d-flex flex-column flex-root h-100'>
  //   <div className='d-flex flex-column flex-center flex-column-fluid p-10'>
  //     <img
  //       src={toAbsoluteUrl('/media/illustrations/sketchy-1/15.png')}
  //       alt=''
  //       className='mw-100 mb-10 h-lg-150px'
  //     />
  //     <h1 className='fw-bold mb-10'>Oops, You don't have any access. </h1>
  //     <button
  //       className='btn btn-primary'
  //       onClick={() => {
  //         loginMutation.mutate(
  //           {},
  //           {
  //             onSuccess: () => {
  //               queryCache.clear()
  //               logout()
  //               window.location.href = '/auth/login'
  //             },
  //           }
  //         )
  //       }}
  //     >
  //       Sign Out
  //     </button>
  //   </div>
  // </div>
}

export { NoAccess }
